import { App } from '@grafikr/components';

import './css/app.css';
import 'vendor/lazysizes';

import components from 'framework/components';
import state from 'framework/state';

const app = new App();

components(app);
state(app);
app.mount();

// import(/* webpackChunkName: "linked-products" */ 'utils/linked-products').then(
//   ({ default: LinkedProducts }) => {
//     window.LinkedProducts = new LinkedProducts();
//     window.LinkedProducts.getProducts();
//   },
// );

document.addEventListener('shopify:section:load', ({ detail }) => {
  const section = document.getElementById(`shopify-section-${detail.sectionId}`);

  if (section) {
    app.mount(section);
  }
});
